/**
 * Access each data property via a property priority array.
 * Each value found is passed to the provided predicate function, valueCheck
 *
 * @template T
 * @param {T} data The data with values to check
 * @param {(keyof T)[]} columnsByPriority Array of keys in order of priority to search the data object
 * @param {(value: T[keyof T]) => boolean} valueCheck Predicate function each value found by data[column]
 * @returns {keyof T} A single key defined in columnsByPriority
 */
export var findKeyByPriority = function (data, columnsByPriority, valueCheck) { return columnsByPriority.find(function (toCheck) {
    if (valueCheck(data[toCheck])) {
        return true;
    }
    return false;
}); };
//# sourceMappingURL=findKeyByPriority.js.map